window.tgam = window.tgam || {};

if (window.tgam.meta !== undefined) {
  // Check the top-level content type, to see what page it is.
  Object.defineProperty(window.tgam.meta, "isStoryPage", {
    get: () => window.tgam.meta.pagetype === "story",
    // Configurable: true is required to make this property mutable. Otherwise, this results in
    // failed unit tests. (E.g., properties are redefined in resources/scripts/src/lib/marketing/containers_test.js
    // and resources/scripts/src/lib/commercial/adops/page-targets_test.js)
    configurable: true
  });
  Object.defineProperty(window.tgam.meta, "isVideoPage", {
    get: () => window.tgam.meta.pagetype === "video",
    configurable: true
  });
  Object.defineProperty(window.tgam.meta, "isSectionPage", {
    get: () => window.tgam.meta.pagetype === "section",
    configurable: true
  });
  Object.defineProperty(window.tgam.meta, "isAuthorPage", {
    get: () => window.tgam.meta.pagetype === "author",
    configurable: true
  });
  Object.defineProperty(window.tgam.meta, "isErrorPage", {
    get: () => window.tgam.meta.pagetype === "error",
    configurable: true
  });
  Object.defineProperty(window.tgam.meta, "isStatic", {
    get: () => window.tgam.meta.pagetype === "static",
    configurable: true
  });

  // Determine which article types do have a right-rail column,
  // but using a *whitelist* of article types that do not have a right-rail.
  // These could also be considered "premium" article types.
  // Not to be confused with "premium" curated section pages.
  Object.defineProperty(window.tgam.meta, "isStoryPremiumPage", {
    get() {
      return window.tgam.meta.isStoryPage && [
        "enriched",
        "embeddable",
        "gallery",
        "video",
        "longread"
      ].indexOf(window.tgam.meta.pagesubtype) > -1;
    },
    configurable: true
  });

  Object.defineProperty(window.tgam.meta, "isStoryInteractivePage", {
    get: () => window.tgam.meta.isStoryPage && window.tgam.meta.pagesubtype === "interactive",
    configurable: true
  });

  Object.defineProperty(window.tgam.meta, "isStoryLongReadPage", {
    get: () => window.tgam.meta.isStoryPage && window.tgam.meta.pagesubtype === "longread",
    configurable: true
  });

  // livesuggest search for financial symbols
  Object.defineProperty(window.tgam.meta, "isSecuritySearchSection", {
    get: () => ["business", "investing", "homepage"].indexOf(window.tgam.meta.siteName) >= 0,
    configurable: true
  });

  // Allow Slimcut served Ads on article pages that are:
  // - standard articles with right-rail layout.
  // - longread articles with single column layout.
  Object.defineProperty(window.tgam.meta, "allowSlimcutAd", {
    get: () => (
      (window.tgam.meta.isStoryPage && window.tgam.meta.pbLayout === "story-2")
      || window.tgam.meta.isStoryLongReadPage
    ),
    configurable: true
  });

  // Allow Nativo served Ads
  // See: https://confluence.theglobeandmail.com/display/ARC/Nativo
  Object.defineProperty(window.tgam.meta, "allowNativoAd", {
    get: () => (
      (window.tgam.meta.pagetype === "story" && window.tgam.meta.pagesubtype !== "interactive")
      || (window.tgam.meta.pagetype === "section" && !window.tgam.meta.isFinancialPage)
      || window.tgam.meta.siteName === "investing/globe-advisor"
    ) && !window.tgam.meta.advContent,
    configurable: true
  });
}

if (window.tgam.env !== undefined) {
  window.tgam.env.analyticsDisabled = /analytics=false/.test(window.location.search) ||
    /\/political\-ad\-collector\//.test(window.location.pathname);
  window.tgam.env.adsDisabled = /ads=false/.test(window.location.search) ||
    /\/political\-ad\-collector\//.test(window.location.pathname);
}

export default window.tgam;
